import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { ForgotPasswordForm } from '@old/features/public/forgot-password/forgot-password-form';

export function ForgotPasswordPage() {
  return (
    <AuthLayoutComponent>
      <ForgotPasswordForm />
    </AuthLayoutComponent>
  );
}
